import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  memo,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Label,
} from 'reactstrap';
import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';
import Button from 'components/App/Button';

import styles from './ModalEditPolicyOther.module.scss';

function ModalEditPolicyOther(props) {
  const {
    isOpen,
    onToggleModal,
    otherPolicy,
    actionEditOtherPolicy,
    actionGetPlaceDetail,
  } = props;

  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const [content, setContent] = useState('');

  useEffect(() => {
    if (isOpen) {
      setContent(otherPolicy || '');
    }
  }, [isOpen, otherPolicy]);

  const handleChange = useCallback((e) => {
    setContent(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      const payload = {
        placeId,
        otherPolicy: content.trim(),
        onCallBackSave: () => {
          onToggleModal();
          if (actionGetPlaceDetail) {
            actionGetPlaceDetail({ placeId });
          }
        },
      };

      if (actionEditOtherPolicy) {
        actionEditOtherPolicy(payload);
      }
    },
    [actionEditOtherPolicy, actionGetPlaceDetail, content, onToggleModal, placeId],
  );

  const CloseButton = useMemo(() => (
    <button className={styles.ButtonClose} onClick={onToggleModal} type="button">
      <CloseButtonSvg />
    </button>
  ), [onToggleModal]);

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="lg"
        isOpen={isOpen}
        toggle={onToggleModal}
        className={styles.Modal}
      >
        <ModalHeader
          toggle={onToggleModal}
          className={styles.ModalHeader}
          close={CloseButton}
        />

        <ModalBody className={styles.ModalBody}>
          <Label className="Label">
            Chính sách khác
          </Label>

          <hr className="Divider" />

          {/* Section 1: Nội dung */}
          <div className="Section">
            <div className="Section__Title">
              Nội dung
            </div>

            <textarea
              id="other-policy-content"
              className={styles.TextArea}
              placeholder="Nhập nội dung..."
              value={content}
              onChange={handleChange}
              rows={4}
            />
          </div>

          <hr className="Divider" />

          {/* Section 2: Lưu ý */}
          <div className="Section">
            <div className="Section__Policy__Title">
              Lưu ý
            </div>
            <div className="Section__Policy__Information__Wrapper">
              <span className="Section__Policy__Information__Content">
                Chính sách này sẽ xuất hiện chung với &quot;Chính sách chung&quot;
                {' '}
                được hiển thị trên Bookese.
              </span>
            </div>
          </div>

          <hr className="Divider" />

          {/* Section 3: Tóm tắt chính sách */}
          <div className="Section">
            <div className="Section__Policy__Title">
              Tóm tắt chính sách
            </div>
            <div className="Section__Policy__Information__Wrapper">
              <span
                className="Section__Policy__Information__Content"
                style={{ whiteSpace: 'pre-line' }}
              >
                {content.trim() || 'Chưa có nội dung tóm tắt.'}
              </span>
            </div>
          </div>

          <hr className="Divider" />

          {/* Action Buttons */}
          <div className="Button__Wrapper">
            <Button
              classes="Button Button__Cancel"
              onClick={onToggleModal}
            >
              Hủy
            </Button>

            <Button classes="Button Button__Save" onClick={handleSubmit}>
              Lưu
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

ModalEditPolicyOther.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggleModal: PropTypes.func.isRequired,
  otherPolicy: PropTypes.string,
  actionEditOtherPolicy: PropTypes.func,
  actionGetPlaceDetail: PropTypes.func,
};

ModalEditPolicyOther.defaultProps = {
  otherPolicy: '',
  actionEditOtherPolicy: () => {},
  actionGetPlaceDetail: () => {},
};

export default memo(ModalEditPolicyOther);
